import { useEffect } from 'react';
import { applyConsentToGtag } from '../Utils/consent.js';
import { analytics } from '../firebaseConfig.jsx';
import { setAnalyticsCollectionEnabled } from 'firebase/analytics';

export default function CookieBanner() {
  useEffect(() => {
    const checkConsent = () => {
      if (typeof window.tarteaucitron === 'undefined') {
        setTimeout(checkConsent, 100);
        return;
      }

      const checkServices = setInterval(() => {
        try {
          const service = window.tarteaucitron.services?.gcmanalyticsstorage;
          if (service?.activated === true) {
            clearInterval(checkServices);
            if (analytics) {
              setAnalyticsCollectionEnabled(analytics, true);
            }
            applyConsentToGtag(true);
          } else if (service?.activated === false) {
            clearInterval(checkServices);
            applyConsentToGtag(false);
          }
        } catch (e) {}
      }, 500);

      setTimeout(() => clearInterval(checkServices), 10000);
    };

    checkConsent();
  }, []);

  return null;
}
